import { Router, Route, Switch } from 'wouter-preact';
import { Layout } from './components/Layout';
import { Chat } from './routes/Chat';
import { TeamMap } from './routes/TeamMap';
import { Sessions } from './routes/Sessions';
import { Knowledge } from './routes/Knowledge';
import { Memories } from './routes/Memories';
import { Schedules } from './routes/Schedules';
import { Approvals } from './routes/Approvals';
import { EvalRuns } from './routes/EvalRuns';
import { Traces } from './routes/Traces';
import { Models } from './routes/Models';
import { Settings } from './routes/Settings';

export function App() {
  return (
    <Router>
      <Layout>
        <Switch>
          <Route path="/" component={Chat} />
          <Route path="/chat" component={Chat} />
          <Route path="/team-map" component={TeamMap} />
          <Route path="/sessions" component={Sessions} />
          <Route path="/knowledge" component={Knowledge} />
          <Route path="/memories" component={Memories} />
          <Route path="/schedules" component={Schedules} />
          <Route path="/approvals" component={Approvals} />
          <Route path="/eval" component={EvalRuns} />
          <Route path="/traces" component={Traces} />
          <Route path="/models" component={Models} />
          <Route path="/settings" component={Settings} />
          <Route>
            <div class="p-8 text-muted-foreground">Página não encontrada.</div>
          </Route>
        </Switch>
      </Layout>
    </Router>
  );
}
